type GoogleStaticMapOptions = {
  latitude: number
  longitude: number
  apiKey: string
  zoom?: number
  width?: number
  height?: number
  mapType?: "roadmap" | "satellite" | "hybrid" | "terrain"
}

export function getGoogleStaticMapUrl({
  latitude,
  longitude,
  apiKey,
  zoom = 14,
  width = 80,
  height = 80,
  mapType = "satellite",
}: GoogleStaticMapOptions): string {
  const params = new URLSearchParams({
    center: `${latitude},${longitude}`,
    zoom: zoom.toString(),
    size: `${width}x${height}`,
    maptype: mapType,
    key: apiKey,
  });

  return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
}
